import {createAction} from 'redux-act';

export const fetchUser = createAction('Fetch User Request')
export const fetchUserSuccessful = createAction('Fetch User Request Success')
export const fetchUserFailure = createAction('Fetch User Request Fail')
export const logout = createAction('Logout User')
export const logoutSuccessful = createAction('Ending Session and Clear Localstorage')


export const updatePreferredLanguage = createAction('Update Language of the User Preferred')
export const updatePreferredLanguageSuccessful = createAction('Update Language of the User Preferred Success')
export const updatePreferredLanguageFailure = createAction('Update Language of the User Preferred Fail')


export const createUser = createAction('Create User Request')
export const createUserSuccessful = createAction('Create User Request Success')
export const createUserFailure = createAction('Create User Request Fail')

export const loginUser = createAction('Login User Request')
export const loginUserSuccessful = createAction('Login User Request Success')
export const loginUserFailure = createAction('Login User Request Fail')
